export const VOUCHER = 'Voucher';
